import React, { useEffect, useState } from 'react';
import Pagination from '../../components/Pagination';
import InnerLayout from '../../components/layouts/innerLayout';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { bulkUploadProductAction, deleteProductAction, listProductAction } from '../../redux/actions/productAction';
import { errorToast, successToast } from '../../components/toast';
import LoaderModal from '../../components/modals/loaderModal';
import { formatDate } from '../../components/helper';
import search from "../../assets/icons/searchIcon.svg";
import editIcon from "../../assets/icons/editIcon.png";  // Import your edit icon
import deleteIcon from "../../assets/icons/deleteIcon.png";
import BulkUploadModal from '../../components/modals/bulkUploadModal';

const ProductList = () => {
    // Dummy data for products (reflecting the schema you provided)
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setSearchValue] = useState('');
    const [debouncedValue, setDebouncedValue] = useState("");
    const [paginationData, setPaginationData] = useState(null);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleUpload = (file) => {
        setLoading(true);
        dispatch(bulkUploadProductAction(file, (data) => { successToast(data.data.message); setLoading(false); fetchProducts(); }, onError));
    };

    const itemsPerPage = 15;
    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= paginationData?.totalPages) {
            setCurrentPage(newPage);
        }
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(searchValue);
            setCurrentPage(1)
        }, 300);

        return () => {
            clearTimeout(handler);
        };
    }, [searchValue]);

    useEffect(() => {
        fetchProducts()
    }, [currentPage, debouncedValue])

    const fetchProducts = () => {
        setLoading(true)
        dispatch(listProductAction({ page: currentPage, search: debouncedValue, page_size: itemsPerPage }, onSuccess, onError))
    }

    const onSuccess = (data) => {
        setProducts(data.data.data.products);
        setPaginationData(data.data.data.pagination)
        setLoading(false)
    }

    const onError = (data) => {
        const errorMsg = data.data.message || "Unable to fetch try later";
        errorToast(errorMsg)
        setLoading(false)
    }

    const handleEdit = (productId) => {
        navigate(`/product/edit/${productId}`);
    };

    const handleDelete = (productId) => {
        setLoading(true)
        dispatch(deleteProductAction({ id: productId }, (data) => {
            successToast(data.data.message);
            fetchProducts()
            setLoading(false)
        }, onError))
    };



    return (
        <InnerLayout module={"Products"} is_new={true} navigationPath={"/product/create"}>
            <div className="w-full flex flex-col h-full p-4">
                <div className="w-full sm:w-auto mb-2 flex flex-wrap justify-between">
                    <div
                        style={{ height: "2.5rem" }}
                        className={`input_border flex items-center rounded-md w-full sm:w-auto mx-1 md:w-1/3`}
                    >
                        <span className="px-2">
                            <img width={"16px"} src={search} alt="search icon" />
                        </span>
                        <input
                            placeholder={`Search here`}
                            className="table_search_input w-full rounded-md placeholder:text-sm py-1 px-2"
                            type="text"
                            value={searchValue}
                            onChange={(e) => {
                                setSearchValue(e?.target?.value);
                            }}
                        />
                        <span className='fs_14 mx-3 cursor-pointer text-primary' onClick={() => setSearchValue('')} >Clear</span>
                    </div>
                    <button
                        onClick={() => setIsModalOpen(true)}
                        className="bg-primary text-white rounded-lg hover:bg-primary-hover px-4 py-2 text-nowrap mt-2 md:mt-0"
                    >
                        Bulk Upload
                    </button>
                </div>
                <div className="bg-white shadow-lg rounded-lg overflow-auto flex-1">
                    <table className="min-w-full table-auto">
                        <thead className="bg-slate-300 sticky top-0">
                            <tr>
                                <th className="px-4 py-2">#</th>
                                <th className="px-4 py-2">Product</th>
                                <th className="px-4 py-2">SKU</th>
                                <th className="px-4 py-2">Hsncode</th>
                                <th className="px-4 py-2">Barcode</th>
                                <th className="px-4 py-2">Price</th>
                                <th className="px-4 py-2">Tax Rate</th>
                                <th className="px-4 py-2">Discount</th>
                                <th className="px-4 py-2">Created At</th>
                                <th className="px-4 py-2">Updated At</th>
                                <th className="px-4 py-2">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {products.length > 0 ? products.map((product) => (
                                <tr key={product.id} className="border-b hover:bg-primary-light cursor-pointer">
                                    <td className="py-2" onClick={() => navigate(`/product/edit/${product.id}`)} >{product.code}</td>
                                    <td className="py-2" onClick={() => navigate(`/product/edit/${product.id}`)} >{product.name}</td>
                                    <td className="py-2" onClick={() => navigate(`/product/edit/${product.id}`)} >{product.sku}</td>
                                    <td className="py-2" onClick={() => navigate(`/product/edit/${product.id}`)} >{product.hsnCode ?? "--"}</td>
                                    <td className="py-2" onClick={() => navigate(`/product/edit/${product.id}`)} >{product.barcode ?? "--"}</td>
                                    <td className="py-2" onClick={() => navigate(`/product/edit/${product.id}`)} >{product.price}</td>
                                    <td className="py-2" onClick={() => navigate(`/product/edit/${product.id}`)} >{product.tax ?? "--"}</td>
                                    <td className="py-2" onClick={() => navigate(`/product/edit/${product.id}`)} >{product.discount}%</td>
                                    <td className="py-2" onClick={() => navigate(`/product/edit/${product.id}`)} >{formatDate(product.createdAt)}</td>
                                    <td className="py-2" onClick={() => navigate(`/product/edit/${product.id}`)} >{formatDate(product.updatedAt)}</td>
                                    <td className="py-2 flex gap-6 justify-center">
                                        {/* Edit Icon */}
                                        <img
                                            src={editIcon}
                                            alt="Edit"
                                            width="20px"
                                            className="cursor-pointer"
                                            onClick={() => handleEdit(product.id)}
                                        />
                                        {/* Delete Icon */}
                                        <img
                                            src={deleteIcon}
                                            alt="Delete"
                                            width="20px"
                                            className="cursor-pointer"
                                            onClick={() => handleDelete(product.id)}
                                        />
                                    </td>
                                </tr>
                            ))
                                : <tr style={{ height: '40rem' }}>
                                    <td colSpan="11" className="py-4 text-center">
                                        No products found
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>


                {/* Pagination Footer */}
                <div className="bg-white p-4 mt-4 shadow-2xl">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={paginationData?.totalPages}
                        onPageChange={handlePageChange}
                    />
                </div>
                {loading &&
                    <LoaderModal />
                }
                <BulkUploadModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    onUpload={handleUpload}
                />
            </div>
        </InnerLayout>
    );
};

export default ProductList;
